import { createContext, useContext } from 'react';

interface CaloriesProviderValue {
  userCaloriesEnabled: boolean;
  toggleCalories?: () => void;
}

export const CaloriesContext = createContext<CaloriesProviderValue>({
  userCaloriesEnabled: true,
});

export const useCalories = () => useContext<CaloriesProviderValue>(CaloriesContext);
